

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSidepage', {

    tag: 'xo-sidepage',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    actions: {
        done: function done() {
            (0, _jquery2['default'])('body').removeClass('sidePageOpen');
            (0, _angular.$timeout)(function () {
                return _uiRouter.$state.go('checkout.review');
            }, 300);
        }
    },

    lifecycle: {
        populate: function populate() {
            (0, _jquery2['default'])('body').addClass('sidePageOpen');
        },
        exit: function exit() {
            this.actions.done();
        }
    }
});


_angular.$timeout;

_squid.$Component;

_uiRouter.$state;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage/directive.js
// module id = ./pages/xo-sidepage/directive.js
// module chunks = 0